import React, { useState } from "react";
import cx from "clsx";
import styles from "./scss/Header.module.scss";
import MobileNav from "./components/MobileNav";
import Logo1 from "../Shared/Icons/Logo/Logo1";
import Logo2 from "../Shared/Icons/Logo/Logo2";
import Logo3 from "../Shared/Icons/Logo/Logo3";
import Logo4 from "../Shared/Icons/Logo/Logo4";
import Logo5 from "../Shared/Icons/Logo/Logo5";
import Logo6 from "../Shared/Icons/Logo/Logo6";
import Logo7 from "../Shared/Icons/Logo/Logo7";
import Logo8 from "../Shared/Icons/Logo/Logo8";
import Logo9 from "../Shared/Icons/Logo/Logo9";
import Logo10 from "../Shared/Icons/Logo/Logo10";
import Logo11 from "../Shared/Icons/Logo/Logo11";
import Logo12 from "../Shared/Icons/Logo/Logo12";
import Logo13 from "../Shared/Icons/Logo/Logo13";
import Logo14 from "../Shared/Icons/Logo/Logo14";
import Button from "../Shared/Button";
import { Link, useLocation } from "react-router-dom";
import classesReponsive from "../Shared/scss/Responsive.module.scss";

const Header = () => {
  const [navShown, setNavShown] = useState(false);
  const location = useLocation();

  const navList = [
    {
      label: "Acasă",
      to: "/",
      match: ["/"],
    },
    {
      label: "Servicii",
      to: "/servicii",
      match: ["/servicii"],
    },
    {
      label: "Tratamente",
      to: "/tratamente",
      match: ["/tratamente"],
    },
    {
      label: "Tarife",
      to: "/tarife",
      match: ["/tarife"],
    },
    {
      label: "Recenzii",
      to: "/recenzii",
      match: ["/recenzii"],
    },
  ];

  return (
    <div className={cx(styles.headerContainer, classesReponsive.paddingLeftRight)}>
      {/* <img src="/images/logo.jpeg" alt="" className={styles.logo} /> */}
      {/* <Logo1 /> */}
      <Logo2 />
      {/* <Logo3 /> */}
      {/* <Logo4 /> */}
      {/* <Logo5 /> */}
      {/* <Logo6 /> */}
      {/* <Logo7 /> */}
      {/* <Logo8 /> */}
      {/* <Logo9 /> */}
      {/* <Logo10 /> */}
      {/* <Logo11 /> */}
      {/* <Logo12 /> */}
      {/* <Logo13 /> */}
      {/* <Logo14 /> */}
      <div
        className={styles.hamburgerButton}
        onClick={() => setNavShown(!navShown)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className={styles.navListDesktop}>
        <ul>
          {navList.map((item) => (
            <li
              className={cx(
                item.match.includes(location.pathname) && styles.active
              )}
            >
              <Link to={item.to}>{item.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <Button className={styles.headerButton}><Link to="/programare">Fă o Programare</Link></Button>
      <MobileNav active={navShown} setActive={setNavShown} />
    </div>
  );
};

export default Header;
